import { useState } from 'react';
import { CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import useUserPool from './useUserPool';

const useSignUp = () => {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorResend, setErrorResend] = useState('');
    const [cognitoUser, setCognitoUser] = useState();

    const { userPool } = useUserPool();

    function signUp({
        email,
        password,
        firstName,
        lastName,
        phone,
        source = '',
        signup_page = ''
    }) {
        return new Promise((resolve, reject) => {
            setLoading(true);
            setError('');
            try {
                const attributeList = [];
                const attributeEmail = new CognitoUserAttribute({ Name: 'email', Value: email });
                const attributePhone = new CognitoUserAttribute({
                    Name: 'custom:phone_number_string',
                    Value: phone
                });
                const attributeFirstName = new CognitoUserAttribute({
                    Name: 'given_name',
                    Value: firstName
                });
                const attributeLastName = new CognitoUserAttribute({
                    Name: 'family_name',
                    Value: lastName
                });
                const attributeSource = new CognitoUserAttribute({
                    Name: 'custom:user_source',
                    Value: source
                });
                const attributeSignupType = new CognitoUserAttribute({
                    Name: 'custom:signup_type',
                    Value: signup_page
                });

                attributeList.push(attributeEmail);
                attributeList.push(attributePhone);
                attributeList.push(attributeFirstName);
                attributeList.push(attributeLastName);
                attributeList.push(attributeSource);
                attributeList.push(attributeSignupType);

                userPool.signUp(email, password, attributeList, null, function (err, result) {
                    if (err) {
                        setLoading(false);
                        const errorMessage = err.message || JSON.stringify(err);
                        setError(errorMessage);
                        return reject(new Error(errorMessage));
                    }
                    setLoading(false);
                    setError('');
                    setCognitoUser(result.user);
                    return resolve('');
                });
            } catch (e) {
                setLoading(false);
                setError(e.message);
                reject(e);
            }
        });
    }

    function resendEmail(email) {
        return new Promise((resolve, reject) => {
            setLoading(true);
            setErrorResend('');
            try {
                let localCognitoUser = cognitoUser;
                if (!cognitoUser) {
                    const userData = {
                        Username: email,
                        Pool: userPool
                    };
                    localCognitoUser = new CognitoUser(userData);
                }
                localCognitoUser.resendConfirmationCode(function (err, result) {
                    if (err) {
                        setLoading(false);
                        const errorMessage = err.message || JSON.stringify(err);
                        setErrorResend(errorMessage);
                        return reject(new Error(errorMessage));
                    }
                    setLoading(false);
                    setErrorResend('');
                    return resolve('');
                });
            } catch (e) {
                setLoading(false);
                setErrorResend(e.message);
                reject(e);
            }
        });
    }

    return { error, errorResend, loading, resendEmail, signUp };
};

export default useSignUp;
